import type { ReactNode } from 'react'
import { StoreLayout } from '../layouts/StoreLayout'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<string, any>

// Shared resolver for both the client and SSR entrypoints. Applies the
// persistent StoreLayout by default (so the audio player keeps playing across
// navigations); a page can opt out with `Page.layout = null`.
export function resolvePage(name: string) {
  const mod = pages[`../pages/${name}.tsx`]
  if (!mod) throw new Error(`Inertia page not found: ${name}`)
  const Page = mod.default
  if (Page.layout === undefined) {
    Page.layout = (page: ReactNode) => <StoreLayout>{page}</StoreLayout>
  }
  return Page
}
